require.context('./fonts', true);

import 'common/styles'
import 'common/src'